var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0278 9.54973L16.3817 1.03714C15.9233 0.596424 15.2429 0.467139 14.6508 0.706874C14.0587 0.946609 13.6684 1.5096 13.6565 2.14071V5.98857C10.2005 6.23303 6.96678 7.75503 4.60579 10.2513C2.24343 12.7465 0.928018 16.029 0.924351 19.4409V20.8454V20.8442C0.919576 21.5552 1.40899 22.1758 2.10851 22.3485C2.24459 22.3885 2.38545 22.4097 2.5287 22.412C3.0981 22.412 3.62332 22.11 3.90385 21.6222L4.14618 21.2085H4.14498C6.11699 17.8132 9.69205 15.6225 13.6565 15.3791V19.14C13.6553 19.7759 14.0456 20.3494 14.6437 20.5915C15.2405 20.8336 15.9281 20.6961 16.3817 20.2424L25.0278 11.7298V11.731C25.6258 11.1234 25.6258 10.1573 25.0278 9.54973ZM15.5676 18.4255L15.5664 14.426C15.57 14.1756 15.4709 13.9347 15.2907 13.7572C15.1116 13.5798 14.8657 13.4822 14.6114 13.4857H14.3691H14.3703C9.70303 13.4893 5.35785 15.8269 2.83429 19.6912V19.4409C2.83667 16.3663 4.07932 13.4186 6.28776 11.2445C8.49494 9.07024 11.4889 7.84797 14.6114 7.84436C15.1391 7.84436 15.5664 7.42362 15.5664 6.90414V2.90464L23.3971 10.665L15.5676 18.4255Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.f7d26ce801572cb84ce2a98946c50216.svg";
export { ForwardRef as ReactComponent };